import { Lodash } from '@intelipost-js/secure-providers';

export default {
  deliveryMethods: state => (logisticProviderId) => {
    if (
      state.logisticProviders.length === 0
      || !logisticProviderId
      || logisticProviderId.length === 0
    ) {
      return [];
    }

    if (Array.isArray(logisticProviderId)) {
      return state.logisticProviders
        .filter(item => logisticProviderId.includes(item.id))
        .map(({ delivery_methods = [] }) => delivery_methods)
        .reduce((acc, currentDms) => [...acc, ...currentDms]);
    }

    const { delivery_methods = [] } = state.logisticProviders
      .find(logisticProvider => logisticProvider.id === logisticProviderId) || {};

    return delivery_methods;
  },
  deliveryMethodsTypes: state => () => {
    if (state.logisticProviders.length === 0) return [];

    const types = state.logisticProviders
      .map(logisticProviders => logisticProviders.delivery_methods.map(dm => dm.type))
      .reduce((dmA, dmB) => [
        ...dmA,
        ...dmB,
      ], [])
      .filter(dmType => dmType);

    return Lodash.uniq(types, 'value')
      .sort((dmA, dmB) => {
        if (dmA.label > dmB.label) {
          return 1;
        }
        return -1;
      });
  },
  allDeliveryMethods(state) {
    return state.logisticProviders
      .map(logisticProvider => Object.assign({}, logisticProvider, {
        delivery_methods: logisticProvider.delivery_methods.map(dm => Object.assign({}, dm, {
          logistic_provider_id: logisticProvider.id,
          logistic_provider_name: logisticProvider.name,
        })),
      }))
      .reduce((itemA, itemB) => ([
        ...itemA,
        ...itemB.delivery_methods,
      ]), [])
      .map(dm => Object.assign({}, dm, {
        enabled: String(dm.enabled),
      }));
  },
  logisticProviderName: state => (logisticProviderId) => {
    if (state.logisticProviders.length === 0 || !logisticProviderId) return null;

    const { name = null } = state.logisticProviders
      .find(logisticProvider => Number(logisticProvider.id) === Number(logisticProviderId)) || {};

    return name;
  },
  deliveryMethodConfigRules(state) {
    const {
      logisticProvider = {},
    } = state || {};
    const {
      delivery_method = {},
    } = logisticProvider || {};
    const {
      config,
    } = delivery_method || {};
    const {
      groups = [],
    } = config || {};

    return groups.map((group) => {
      const {
        fields = [],
      } = group || [];

      return fields.map((field) => {
        const {
          id,
          label,
          rule,
          required,
        } = field || [];

        const rules = [];

        rules.push({
          type: rule,
          required,
          message: `Preencha o <strong>${label}</strong> corretamente`,
          trigger: 'input',
        });

        return {
          [id]: rules,
        };
      })
        .reduce((a, b) => ({
          ...a,
          ...b }), {});
    })
      .reduce((a, b) => ({
        ...a,
        ...b }), {});
  },
  deliveryMethodConfigForm(state) {
    const {
      logisticProvider = {},
    } = state || {};
    const {
      delivery_method = {},
    } = logisticProvider || {};
    const {
      config,
    } = delivery_method || {};
    const {
      groups = [],
    } = config || {};

    return groups.map((group) => {
      const {
        fields = {},
      } = group;

      return fields
        .map((field) => {
          let value = field.value;
          if (['integer'].indexOf(field.type.toLowerCase()) > -1) {
            try {
              value = JSON.parse(value);
            } catch(e) {} //eslint-disable-line
          }

          return {
            [field.id]: value,
          };
        })
        .reduce((a, b) => ({ ...a, ...b }), {});
    }).reduce((a, b) => ({ ...a, ...b }), {});
  },
};



// WEBPACK FOOTER //
// ./src/stores/logistic-providers/getters.js